(function() {
  'use strict';
  angular.module('providerPortal')
  .directive('globalErrors', ['$timeout', '$rootScope', '$window', function($timeout, $rootScope, $window) {
    return {
      templateUrl: '/js/globalErrors.html' + appVersion,
      scope: {},
      link: function ($scope, $window) {
        $scope.dismiss = () => {
          $scope.globalError = undefined;
        };
        var errorHandler = _.curry(function(errorType, event, response) {
          if (response && response.status === 403) {
            return;
          }
          $timeout(function() {
            $scope.$apply(function() {
              $scope.globalError = {};
              $scope.globalError[errorType] = true;
              if (response && response.data) $scope.exceptionId = response.data.exceptionId;
              window.setTimeout(function() {
                $(window).scrollTop(0);
              }, 0);
            });
          });
        }, 2);
        $scope.$on('ajaxError', errorHandler('ajaxError'));
        $scope.$on('exceptionIdReceived', errorHandler('clientError'));
        $scope.$on('authorizationError', errorHandler('authorizationError')); //403 Authorization Error
      }
    };
  }]);
})();
